module.exports = __webpack_public_path__ + "img/I@2x.d52a6b48.jpg";